import type { MutationConfig } from "apps/visits/core/lib/react-query";
import { useMutation } from "react-query";
import { useGetSlug } from "../store/use-config";
import { GroupActionsOrderingRepository } from "./group-actions-ordering.api";

const groupActionsOrderingRepository = new GroupActionsOrderingRepository();

type UseRegisterOptions = {
  config?: MutationConfig<typeof groupActionsOrderingRepository.register>;
};

export const useRegister = ({ config }: UseRegisterOptions) => {
  const slug = useGetSlug();

  return useMutation({
    ...config,
    mutationFn: (data) => groupActionsOrderingRepository.register(data, slug),
  });
};
